var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Lencore {
    constructor(log) {
        this.apiToken = '31415926535897932384626433832795028841971693993751';
        this.numChannelsPerOp = 4;
        this.numOps = 4;
        this.numZones = 255;
        this.ops = []; // two OPs, each with 4 channels
        this.zones = [];
        this.asyncHandlers = [
            {
                name: 'getToken',
                path: /\/rest\/login\?username=(.*)&password=.*/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return match[1] !== 'failure' // use name failure for testing authFailed
                        ? {
                            data: {
                                message: 'Logged in ok',
                                data: { token: this.apiToken },
                                error: null,
                            },
                        }
                        : {
                            data: {
                                message: 'Failure logging in',
                                data: null,
                                error: { name: 'AccessDenied', message: 'Invalid credentials' },
                            },
                        };
                }),
            },
            {
                name: 'mainProcessing',
                path: /\/rest\/method\/TPI\/control\?happn_token=(.+)/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    if (match[1] === this.apiToken) {
                        const response = this.processRequest(req.data.parameters);
                        return { data: response };
                    }
                    return {
                        data: {
                            message: 'Call failed',
                            data: null,
                            error: { name: 'AccessDenied', message: 'Invalid token' },
                        },
                    };
                }),
            },
            {
                name: 'invalid',
                path: /.+/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return {
                        data: {
                            message: 'Call failed',
                            data: null,
                            error: { message: 'No Valid Rest Parameters' },
                        },
                    };
                }),
            },
        ];
        for (let z = 0; z < this.numZones; z++) {
            this.zones.push({ mute: false, volume: 32 });
        }
        for (let op = 0; op < this.numOps; op++) {
            const opSettings = { masking: [], music: [], paging: [] };
            for (let c = 0; c < this.numChannelsPerOp; c++) {
                opSettings.masking.push({ mute: false, volume: 49 });
                opSettings.music.push({ mute: false, volume: 43 });
                opSettings.paging.push({ mute: false, volume: 43 });
            }
            this.ops.push(opSettings);
        }
    }
    // Create Bytes 11 and 12 from the mute status information to send back when the status of all
    // channels is requested.
    //
    // Bit 0 = masking mute of channel A
    // Bit 1 = paging mute of channel A
    // Bit 2 = music mute of channel A
    // etc.
    //
    // |      Byte 11       |   Byte 12     |
    // 15 14 13 12 11 10 9 8 7 6 5 4 3 2 1 0
    //              |  | | | | | | | | | | \- Mask A Mute
    //              |  | | | | | | | | | \---   Page A Mute
    //              |  | | | | | | | | \-----   Music A Mute
    //              |  | | | | | | | \------- Mask B Mute
    //              |  | | | | | | \---------   Page B Mute
    //              |  | | | | | \-----------   Music B Mute
    //              |  | | | | \------------- Mask C Mute
    //              |  | | | \---------------   Page C Mute
    //              |  | | \-----------------   Music C Mute
    //              |  | \------------------- Mask D Mute
    //              |  \---------------------   Page D Mute
    //              \------------------------   Music D Mute
    generateMuteStatus(opId) {
        let muteStatus = 0;
        let byteOffset = 1;
        for (let i = 0; i < 4; i++) {
            muteStatus += this.ops[opId].masking[i].mute ? 1 * byteOffset : 0;
            muteStatus += this.ops[opId].paging[i].mute ? 2 * byteOffset : 0;
            muteStatus += this.ops[opId].music[i].mute ? 4 * byteOffset : 0;
            byteOffset *= 8;
        }
        return [(muteStatus & 0xff00) >> 8, muteStatus & 0x00ff];
    }
    processRequest(req) {
        const subCommand = req.OPSubCommand;
        const address = req.OPAddress - 1;
        const groupSelect = req.OPGroupSelect;
        const commandCat = req.OPCommandCat;
        let channelNum = 0;
        if (groupSelect === 0) {
            //individual
            if (subCommand <= 4) {
                // set values for individual channels A-D (0-3)
                channelNum = subCommand - 1;
                const volumeValue = req.OPData ? req.OPData[0] : 49;
                // set the volume level for the channel on the OPs specified
                // by the OPAddress (1 or 2)
                if (commandCat === 1) {
                    this.ops[address].masking[channelNum].volume = volumeValue;
                }
                else if (commandCat === 10) {
                    this.ops[address].paging[channelNum].volume = volumeValue;
                }
                else {
                    this.ops[address].music[channelNum].volume = volumeValue;
                }
                return {
                    message: 'Call successful',
                    data: {
                        OPAddress: req.OPAddress,
                        OPResultCode: 1,
                        OPCommandCat: commandCat,
                        OPSubCommand: subCommand,
                        OPTransactionID: req.OPTransactionID,
                        OPData: [volumeValue],
                        OPDataCount: 7,
                    },
                    error: null,
                };
            }
            else if (subCommand === 5) {
                // set values for all channels A-D (0-3) from one array value
                const volumeValue = req.OPData ? req.OPData[0] : 49;
                // set the volume level for the channel on the OPs specified
                // by the OPAddress (1 or 2)
                for (let i = 0; i < 4; i++) {
                    if (commandCat === 1) {
                        this.ops[address].masking[i].volume = volumeValue;
                    }
                    else if (commandCat === 10) {
                        this.ops[address].paging[i].volume = volumeValue;
                    }
                    else {
                        this.ops[address].music[i].volume = volumeValue;
                    }
                }
                return {
                    message: 'Call successful',
                    data: {
                        OPAddress: req.OPAddress,
                        OPResultCode: 1,
                        OPCommandCat: commandCat,
                        OPSubCommand: subCommand,
                        OPTransactionID: req.OPTransactionID,
                        OPData: [volumeValue],
                        OPDataCount: 7,
                    },
                    error: null,
                };
            }
            else if (subCommand <= 9) {
                // get values for individual channels A - D (0 - 3)
                channelNum = subCommand - 6;
                let volumeValue = 0;
                if (commandCat === 1)
                    volumeValue = this.ops[address].masking[channelNum].volume;
                else if (commandCat === 10)
                    volumeValue = this.ops[address].paging[channelNum].volume;
                else
                    volumeValue = this.ops[address].music[channelNum].volume;
                return {
                    message: 'Call successful',
                    data: {
                        OPAddress: req.OPAddress,
                        OPResultCode: 1,
                        OPCommandCat: commandCat,
                        OPSubCommand: subCommand,
                        OPTransactionID: req.OPTransactionID,
                        OPData: [volumeValue],
                        OPDataCount: 7,
                    },
                    error: null,
                };
            }
            else if (subCommand === 10) {
                // Query to get all volume and mute status
                //this.log.debug(`emulator: entering request all states`);
                // eslint-disable-next-line prefer-const
                let responseData = Array(6).fill(0);
                // request current value for all channels
                for (let i = 0; i < 4; i++) {
                    if (commandCat === 1)
                        responseData[i] = this.ops[address].masking[i].volume;
                    else if (commandCat === 10)
                        responseData[i] = this.ops[address].paging[i].volume;
                    else
                        responseData[i] = this.ops[address].music[i].volume;
                }
                const muteStatus = this.generateMuteStatus(address);
                responseData[4] = muteStatus[0];
                responseData[5] = muteStatus[1];
                return {
                    message: 'Call successful',
                    data: {
                        OPAddress: req.OPAddress,
                        OPResultCode: 1,
                        OPCommandCat: commandCat,
                        OPSubCommand: subCommand,
                        OPTransactionID: req.OPTransactionID,
                        OPDataCount: 12,
                        OPData: responseData,
                    },
                    error: null,
                };
            }
            else if (subCommand >= 16 && subCommand <= 19) {
                // Set individual muting channels on the specific OP
                const muteValue = req.OPData ? req.OPData[0] === 1 : false;
                channelNum = subCommand - 16;
                if (commandCat === 1) {
                    this.ops[address].masking[channelNum].mute = muteValue;
                }
                else if (commandCat === 10) {
                    this.ops[address].paging[channelNum].mute = muteValue;
                }
                else {
                    this.ops[address].music[channelNum].mute = muteValue;
                }
                return {
                    message: 'Call successful',
                    data: {
                        OPAddress: req.OPAddress,
                        OPResultCode: 1,
                        OPCommandCat: commandCat,
                        OPSubCommand: subCommand,
                        OPTransactionID: req.OPTransactionID,
                        OPData: [muteValue ? 1 : 0],
                        OPDataCount: 7,
                    },
                    error: null,
                };
            }
            else if (subCommand === 20) {
                // Control mute on all channels on the specific OP
                const muteValue = req.OPData ? req.OPData[0] === 1 : false;
                for (let i = 0; i < 4; i++) {
                    if (commandCat === 1) {
                        this.ops[address].masking[i].mute = muteValue;
                    }
                    else if (commandCat === 10) {
                        this.ops[address].paging[i].mute = muteValue;
                    }
                    else {
                        this.ops[address].music[i].mute = muteValue;
                    }
                }
                return {
                    message: 'Call successful',
                    data: {
                        OPAddress: req.OPAddress,
                        OPGroupSelect: groupSelect,
                        OPResultCode: 1,
                        OPCommandCat: commandCat,
                        OPSubCommand: subCommand,
                        OPTransactionID: req.OPTransactionID,
                        OPData: [muteValue ? 1 : 0],
                        OPDataCount: 7,
                    },
                    error: null,
                };
            }
        }
        else if (groupSelect && groupSelect <= 20) {
            // mask, page, or music group.  The group number is the address field.
            // Set mask/paging/music attenuation
            if (subCommand == 1) {
                const volumeValue = req.OPData ? req.OPData[0] : 49;
                // set the volume level for the zone
                this.zones[address].volume = volumeValue;
                return {
                    message: 'Call successful',
                    data: 'Success',
                    error: null,
                };
            }
            else if (subCommand === 6) {
                // Set the mute state of the Zone
                const muteValue = req.OPData ? req.OPData[0] === 1 : false;
                this.zones[address].mute = muteValue;
                // Zone commands don't report back an actual status info, just
                // that the command executed.
                return {
                    message: 'Call successful',
                    data: 'Success',
                    error: null,
                };
            }
        }
        else {
            // mask groups, page groups, music groups, or global select
            return {
                message: 'Call successful',
                data: 'Success',
                error: null,
            };
        }
        return {
            message: 'Call failed',
            data: {
                OPAddress: req.OPAddress,
                OPResultCode: 2,
                OPCommandCat: commandCat,
                OPSubCommand: subCommand,
                OPTransactionID: req.OPTransactionID,
            },
        };
    }
}
Lencore.emulatorType = 'httpRequestEmulator';
Lencore.key = '-MSwZEMSYwDw35Wsje6M';
